<template>
    <div class="w-upload-image">
        <div v-if="data" class="u-image" :style="{ width, height }">
            <img class="u-image-pic" :src="data" />
            <i class="u-image-mask"></i>
            <i class="u-image-delete" title="移除" @click="remove"
                ><svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.36 359.35" fill="#fff" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M35.92 71.9H13.45C5.45 71.9.04 67.04 0 59.99s5.38-12 13.31-12H95.8v-4.84c.19-8.09-.38-16.29.8-24.24C98.23 8 108.07.19 119.13.14q48.47-.19 96.93 0a23.63 23.63 0 0123.42 23.43c.15 8 0 15.93 0 24.42h83.17c9.11 0 15 8.22 11.87 16.3a12 12 0 01-11.4 7.61c-7.72.07-15.45 0-23.7 0v243.64c0 21.13-12.6 37.68-32.45 42.52a45.47 45.47 0 01-10.73 1.23q-88.32.1-176.64 0c-25.34 0-43.64-18.33-43.65-43.67V77.23zm23.95.16V315.54c0 12.37 7.46 19.84 19.76 19.84h175.5c13.07 0 20.31-7.29 20.31-20.44V72.05zm155.53-47.8h-95.34v23.49h95.34z"/><path d="M115.97 203.48v-71.47a11.87 11.87 0 0122.81-4.94 16 16 0 011.07 5.82q.09 70.73 0 141.45c0 7.66-5 13.06-11.87 13.13-7.06.08-12.05-5.37-12.06-13.26q.02-35.37.05-70.73zM219.36 203.65v71.09c0 6.9-4.43 12-10.72 12.68a12.12 12.12 0 01-13.16-11c-.08-.87-.06-1.75-.06-2.62V133.47c0-5.61 1.82-10.06 7.06-12.53a11.83 11.83 0 0116.81 10.86c.15 10.47 0 20.95 0 31.43q.09 20.21.07 40.42z"/></svg></i>
        </div>
        <div v-else class="u-upload" @click="select" :style="{ width, height }">
            <i class="u-upload-icon">＋</i>
        </div>
        <input class="u-upload-input" type="file" @change="add" ref="uploadInput" :accept="accept" />
    </div>
</template>

<script>
// import { getCdnLink } from "@deepberry/common/js/utils";
import Setting from "../../setting.json";
export default {
    name: "UploadImage",

    emits: ["update"],

    props: {
        //当前的图片地址
        url: {
            type: String,
            default: "",
        },
        //图片展示宽度（请指定单位）
        width: {
            type: String,
            default: "", //不要质疑这里，根据需要可以使用百分比或vw等其它单位
        },
        //图片展示高度（请指定单位）
        height: {
            type: String,
            default: "",
        },
    },

    data: function () {
        return {
            data: this.url || "",
            file: null,
            accept: Setting.ImageWhiteList.join(","),
        };
    },
    watch: {
        url: function (val) {
            this.data = val;
        },
    },
    computed: {
        // preview: function () {
        //     return getCdnLink(this.data);
        // },
    },
    methods: {
        select: function () {
            this.$refs.uploadInput.dispatchEvent(new MouseEvent("click"));
        },
        add: function (e) {
            this.file = e.target.files[0];
            this.data = window.URL.createObjectURL(this.file);
            this.$emit("update", this.file);
        },
        remove: function () {
            this.$refs.uploadInput.value = "";
            this.data = "";
            this.data.startsWith("blob:") && window.URL.revokeObjectURL(this.data);
            this.$emit("update", "");
        },
    },
};
</script>

<style lang="less">
@import "../assets/css/components/UploadImage.less";
</style>
